import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Link from "@material-ui/core/Link";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "./LoginSignUpTab.css";

class LoginSignUpTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bottomNavigation: [
        {
          label: "Customer",
        },
        {
          label: "Author",
        },
      ],
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <Paper>
        <Link href="/" className={classes.title}>
          Digi-Book
        </Link>
        <Tabs
          variant="fullWidth"
          value={this.props.currentPage}
          onChange={this.props.handleCurrentPage}
          TabIndicatorProps={{ style: { background: "#181818" } }}
          style={{ outline: "none" }}
        >
          {this.state.bottomNavigation.map((option, index) => (
            <Tab
              key={index}
              label={option.label}
              value={option.label}
              classes={{
                root: classes.root,
                selected: classes.selectedStyle,
              }}
              className={classes.navStyle}
              disableRipple
            />
          ))}
        </Tabs>
      </Paper>
    );
  }
}

export default withStyles(useStyles)(LoginSignUpTab);
